import { AppBar, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import Logo from "../../img/portal_icon_cc logo.svg";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { selectAccount } from "../../redux/UserSlice";
import { logoutAPI } from "../../redux/UserAPI";
import LogoutIcon from "../../img/icons_logout.svg";
import home from "../../img/icons_home.svg";
import profile from "../../img/icons_profile.svg";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getMenuIconSize, getScreenSize } from "../../utils/getScreenSize";
import theme from "../../theme";

export function TopBar() {
  const dispatch = useAppDispatch();
  const account = useAppSelector(selectAccount);
  const history = useHistory();

  const width = window.screen.width;
  const size = getScreenSize(width);
  const iconSize = getMenuIconSize(size);

  return (
    <AppBar position="absolute" color="primary">
      <Grid
        container
        alignItems={"flex-end"}
        justifyContent={"space-between"}
        sx={{
          paddingLeft: 2,
          paddingRight: 2,
          overflow: "hidden",
          [theme.breakpoints.up("xl")]: {
            height: "10em",
          },
          [theme.breakpoints.up("sm")]: {
            height: "7em",
          },
          [theme.breakpoints.up("xs")]: {
            height: "8em",
          },
        }}
      >
        <Grid item xs={3} lg={2}>
          <Link to={"/"}>
            <img
              src={Logo}
              alt="logo"
              style={{ marginBottom: 0, paddingLeft: 4 }}
            />
          </Link>{" "}
        </Grid>
        <Grid item xs={5} lg={8}>
          <Typography
            color={"white"}
            variant="h2"
            sx={{
              [theme.breakpoints.up("xl")]: {
                fontSize: 48,
              },
              [theme.breakpoints.up("sm")]: {},
              [theme.breakpoints.up("xs")]: {
                fontSize: 36,
              },
            }}
          >
            EAP Portal
          </Typography>
        </Grid>
        <Grid item xs={3} lg={2}>
          <Grid
            container
            spacing={0.5}
            alignItems="center"
            justifyContent={"flex-end"}
          >
            {account ? (
              <Grid xs={4} md={3} lg={2} item>
                <Tooltip title="Logout">
                  <IconButton
                    sx={{ padding: 0 }}
                    onClick={() => {
                      dispatch(logoutAPI(false));
                      history.push("/");
                    }}
                  >
                    <img
                      src={LogoutIcon}
                      alt="logout"
                      style={{ width: iconSize, height: iconSize }}
                    />
                  </IconButton>
                </Tooltip>
              </Grid>
            ) : null}
            {account ? (
              <Grid xs={4} md={3} lg={2} item>
                <Tooltip title="Profile">
                  <IconButton sx={{ padding: 0 }}>
                    <Link to="/user_page" style={{ height: iconSize }}>
                      <img
                        src={profile}
                        alt="profile"
                        style={{ width: iconSize, height: iconSize }}
                      />
                    </Link>
                  </IconButton>
                </Tooltip>
              </Grid>
            ) : null}

            <Grid xs={4} md={3} lg={2} item>
              <Tooltip title="Home page">
                <IconButton>
                  <Link
                    to="/"
                    style={{
                      marginRight: "1em",
                      height: iconSize,
                      width: iconSize,
                    }}
                  >
                    <img src={home} alt="home" />
                  </Link>
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AppBar>
  );
}
